<div class="d-none d-md-block delivery">
  @if (isExternalAccountsReceivable) {
    <span class="external-accounts-receivable">{{ deliveryText | translate }}</span>
  } @else {
    <i
      [ngClass]="iconClass"
      class="delivery-i"
      role="img"
      [attr.aria-label]="deliveryText | translate"
      [attr.title]="deliveryText | translate"
    ></i>
  }
</div>
<div class="d-block d-md-none">
  <div [ngClass]="textClass" class="delivery-text">
    <i
      [ngClass]="iconClass"
      class="delivery-i mobile-i"
      role="img"
      [attr.aria-label]="deliveryText | translate"
      [attr.title]="deliveryText | translate"
    ></i>
    {{ deliveryText | translate }}
  </div>
</div>
